var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.75C1.86193 1.75 1.75 1.86193 1.75 2V6C1.75 6.13807 1.86193 6.25 2 6.25H6C6.13807 6.25 6.25 6.13807 6.25 6V2C6.25 1.86193 6.13807 1.75 6 1.75H2ZM0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H6C6.9665 0.25 7.75 1.0335 7.75 2V6C7.75 6.9665 6.9665 7.75 6 7.75H2C1.0335 7.75 0.25 6.9665 0.25 6V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75C11.8619 1.75 11.75 1.86193 11.75 2V6C11.75 6.13807 11.8619 6.25 12 6.25H16C16.1381 6.25 16.25 6.13807 16.25 6V2C16.25 1.86193 16.1381 1.75 16 1.75H12ZM10.25 2C10.25 1.0335 11.0335 0.25 12 0.25H16C16.9665 0.25 17.75 1.0335 17.75 2V6C17.75 6.9665 16.9665 7.75 16 7.75H12C11.0335 7.75 10.25 6.9665 10.25 6V2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.75C1.86193 11.75 1.75 11.8619 1.75 12V16C1.75 16.1381 1.86193 16.25 2 16.25H6C6.13807 16.25 6.25 16.1381 6.25 16V12C6.25 11.8619 6.13807 11.75 6 11.75H2ZM0.25 12C0.25 11.0335 1.0335 10.25 2 10.25H6C6.9665 10.25 7.75 11.0335 7.75 12V16C7.75 16.9665 6.9665 17.75 6 17.75H2C1.0335 17.75 0.25 16.9665 0.25 16V12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.75C11.8619 11.75 11.75 11.8619 11.75 12V16C11.75 16.1381 11.8619 16.25 12 16.25H16C16.1381 16.25 16.25 16.1381 16.25 16V12C16.25 11.8619 16.1381 11.75 16 11.75H12ZM10.25 12C10.25 11.0335 11.0335 10.25 12 10.25H16C16.9665 10.25 17.75 11.0335 17.75 12V16C17.75 16.9665 16.9665 17.75 16 17.75H12C11.0335 17.75 10.25 16.9665 10.25 16V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBashboardIcon);
export default __webpack_public_path__ + "static/media/bashboardIcon.3db3086494c4e06c4a3a84f7a85e670e.svg";
export { ForwardRef as ReactComponent };